import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";
import { isNoldDomain } from "../lib/domain";

const ZoneContext = createContext(null);

const FALLBACK = { zone: "africa", serverZone: "africa", detectCc: null, isSuperAdmin: false, zoneView: null, setZoneView: () => {} };

export function ZoneProvider({ children }) {
  const { user } = useAuth();
  const isSuperAdmin = !!(user && typeof user === "object" && user.is_super_admin);

  const [serverZone, setServerZone] = useState(null); // authoritative IP-based zone
  const [detectCc, setDetectCc] = useState(null);
  const [zoneView, setZoneViewState] = useState(() => localStorage.getItem("bsg_admin_zone_view") || null);

  useEffect(() => {
    api.get("/region/detect")
      .then((r) => { setServerZone(r.data?.zone === "europe" ? "europe" : "africa"); setDetectCc(r.data?.country_code || null); })
      .catch(() => setServerZone("africa"));
  }, []);

  const setZoneView = useCallback((z) => {
    if (z) localStorage.setItem("bsg_admin_zone_view", z);
    else localStorage.removeItem("bsg_admin_zone_view");
    setZoneViewState(z);
  }, []);

  // Domaine noldgo.com → zone Europe FORCÉE pour tous. Sinon : zone IP serveur (le super-admin peut la surcharger).
  const zone = isNoldDomain() ? "europe" : (isSuperAdmin && zoneView ? zoneView : serverZone);

  return (
    <ZoneContext.Provider value={{ zone, serverZone: serverZone || "africa", detectCc, isSuperAdmin, zoneView, setZoneView }}>
      {children}
    </ZoneContext.Provider>
  );
}

export const useZone = () => useContext(ZoneContext) || FALLBACK;
